module.exports = __webpack_public_path__ + "static/media/elvinger.b96e83c7.png";